import { ServiceOSGlobalSettings } from './getServiceOSGlobalSettings';

interface EmailVerificationQueryParams {
  searchParams: URLSearchParams | null;
  values: {
    email: string | null;
    verificationToken: string | null;
  };
}

export function getServiceOSEmailVerificationQueryParams(
  serviceOSGlobalSettings: ServiceOSGlobalSettings
) {
  const { verificationTokenQueryParam = null, emailQueryParam = null } =
    serviceOSGlobalSettings?.emailVerification || {};

  const params: EmailVerificationQueryParams = {
    searchParams: null,
    values: {
      email: null,
      verificationToken: null,
    },
  };

  if (typeof window === 'undefined') {
    return params;
  }

  if (!verificationTokenQueryParam || !emailQueryParam) {
    return params;
  }

  const searchParams = new URLSearchParams(window.location.search);

  const verificationToken = searchParams.get(verificationTokenQueryParam) || null;
  const email = searchParams.get(emailQueryParam) || null;

  if (!verificationToken || !email) {
    return params;
  }

  params.searchParams = searchParams;
  params.values.verificationToken = verificationToken;
  params.values.email = email;

  return params;
}
